import React, { FunctionComponent } from 'react';
import { IWidgetKpiBodyParams } from './types';
import { WidgetKpiRowGroup } from './WidgetKpiRowGroup';
import WidgetKpiSortableRow from './WidgetKpiSortableRow';

export const WidgetKpiBody: FunctionComponent<IWidgetKpiBodyParams> = ({ kpiRowIds, kpisGroupedByUser }) => {
  // const dispatch = useDispatch();
  // const kpiRows = useSelectWithParams(kpiRowSelectors.selectResourcesById, kpiRowIds) as IKpiRow[];
  // const filteredRowIds = kpiRows.filter((row) => row.userId === userId).map((row) => row.id);
  // const [rows, setRows] = useState<string[]>(filteredRowIds);
  // useEffect(() => {
  //   const filteredRows = kpiRows.filter((row) => row.userId === userId).map((row) => row.id);
  //   if (filteredRows.length > rows.length || JSON.stringify(filteredRows) !== JSON.stringify(rows)) {
  //     setRows(filteredRows);
  //   }
  // }, [kpiRows, rows, userId]);

  // const handleDrop = useCallback(
  //   (result: DropResult) => {
  //     if (result.destination) {
  //       const rowId = result.draggableId;
  //       const sourceIndex = result.source.index;
  //       const destinationIndex = result.destination.index;

  //       if (sourceIndex !== destinationIndex) {
  //         if (destinationIndex > sourceIndex) {
  //           rows.splice(sourceIndex, 1);
  //           const newRows = [...rows.slice(0, destinationIndex - 1), rowId, ...rows.slice(destinationIndex - 1)];
  //           setRows(newRows);
  //           dispatch(saveScoreOrder(newRows));
  //         } else {
  //           rows.splice(sourceIndex, 1);
  //           const newRows = [...rows.slice(0, destinationIndex), rowId, ...rows.slice(destinationIndex)];
  //           setRows(newRows);
  //           dispatch(saveScoreOrder(newRows));
  //         }
  //       }
  //     }
  //   },
  //   [rows, dispatch],
  // );

  return (
    <>
      {/* <DragDropContext
        onDragEnd={handleDrop}
      > */}
      <>
        {kpisGroupedByUser ? (
          <WidgetKpiRowGroup kpiRowIds={kpiRowIds} />
        ) : (
          kpiRowIds.map((kpiRowId, index) => <WidgetKpiSortableRow key={index} kpiRowId={kpiRowId} index={index} />)
        )}
      </>
      {/* </DragDropContext> */}
    </>
  );
};
